import { produce } from 'immer';
import { APP_INIT_FAILURE, APP_INIT_SUCCESS } from "./appConstants";

export const initialState = {
    accessLevels: [],
    inited: false,
    user: {}
};

const appReducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {

            case APP_INIT_SUCCESS:
                draft.inited = true;
                if (action.payload.user) {
                    draft.user = action.payload.user;
                }
                if (action.payload.access_levels) {
                    draft.accessLevels = action.payload.access_levels;
                }
                break;

            case APP_INIT_FAILURE:
                draft.inited = true;
                break;

            default:
                return state;
        }
    });

export default appReducer;
